import axios from '@axios'

const PREFIX = '/manuais'

export default {
  getUrlManual() {
    return axios.get(`${PREFIX}/manual-login`)
  },
}
